import { Injectable } from '@angular/core';
import { IMessage, Rating } from '../../interfaces/message.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnswerRatingService {
  constructor(private http: HttpClient) {}

  /**
   * This method sends the rating to the backend
   * @param {IMessage} message
   * @returns {void}
   */
  public async updateAnswerRating(
    message: Pick<IMessage, 'id' | 'rating'>,
    newRating: Rating
  ): Promise<boolean> {
    const oldRating = message.rating;
    message.rating = newRating;
    try {
      await firstValueFrom(
        this.http.post(`/api/v1/messages/${message.id}/feedback`, {
          rating: newRating,
        })
      );
      return true;
    } catch (error) {
      message.rating = oldRating;
      return false;
    }
  }

  /**
   * This method is used to mark the message to be checked by a human.
   * @param {string} email The email-address of the user
   * @param {string} messageId The id of the message to be checked
   * @returns {void}
   */
  public async requestHumandAssistance(email: string, messageId: string): Promise<boolean> {
    try {
      await firstValueFrom(
        this.http.post(`/api/v1/messages/${messageId}/request_human`, { email })
      );
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * This method validates the email and return true if it is valid through a regex
   * @param {string} email
   * @returns {boolean}
   */
  public isEmailValid(email: string): boolean {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(email);
  }
}
